import React from 'react';

import styles from './style.css';

const ContactFormSuccess = () => (
  <div className={styles.contact__form__success__text}>
    Your message has been sent!
    <br />
    Will get back to you in no time.
  </div>
);

export default ContactFormSuccess;
